import App from './App.vue'
import router from '@/config/router'
import store from '@/stores/store'
import interceptor from '@/config/interceptor'
import Vue from 'vue'
import vuetify from './plugins/vuetify'
import '@/scss/styles.scss'
import './scss/iconos.css'
import VueMoment from 'vue-moment'
import Vue2Filters from 'vue2-filters'
import VueHtml2Canvas from 'vue-html2canvas'
import AsyncComputed from 'vue-async-computed'
import moment from 'moment'
//charts
import ECharts from 'vue-echarts' // refers to components/ECharts.vue in webpack

// import ECharts modules manually to reduce bundle size
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'moment/locale/es'
import {notificationsService} from '@/services/notificationsService'

require('xdlocalstorage')

Vue.config.productionTip = false

Vue.use(Vue2Filters)
Vue.use(VueHtml2Canvas)
Vue.use(VueMoment, {
  moment
})

Vue.use(AsyncComputed)
Vue.use(interceptor)
Vue.component('chart', ECharts)

new Vue({
  vuetify,
  render: h => h(App),
  router,
  store
}).$mount('#app')

Vue.prototype.$notificationsService = notificationsService

/**
 * Para compartir sesion con el wordpress tcc.com.co
 * https://github.com/ofirdagan/cross-domain-local-storage
 **/
window.xdLocalStorage.init({
  iframeUrl: 'https://www.tcc.net.co/client.html',
  initCallback: function () {
    // console.log('Got iframe ready')
  }
})
